import actions from '@/modules/configuracoes/site-de-cadastramento/store/actions.js'
import cloneDeep from 'lodash/cloneDeep'
import state from '@/modules/configuracoes/site-de-cadastramento/store/state.js'
import mutations from '@/modules/configuracoes/site-de-cadastramento/store/mutations.js'
import getters from '@/modules/configuracoes/site-de-cadastramento/store/getters.js'

export default {
  namespaced: true,
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
